"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bluesuedeshoes = '#0071C4';
exports.plum = '#650360';
exports.white = '#FFF';
exports.defaultFill = exports.bluesuedeshoes;
//# sourceMappingURL=constants.js.map